import { render, staticRenderFns } from "./ShiftEmployees.vue?vue&type=template&id=501b8671&scoped=true&"
import script from "./ShiftEmployees.vue?vue&type=script&lang=js&"
export * from "./ShiftEmployees.vue?vue&type=script&lang=js&"
import style0 from "./ShiftEmployees.vue?vue&type=style&index=0&id=501b8671&lang=scss&scoped=true&"
import style1 from "./ShiftEmployees.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b8671",
  null
  
)

export default component.exports